import * as React from 'react';
import { toast } from 'react-toastify';

import { AccountAndContactInfo } from './AccountAndContactInfo';
import { FUNNEL_URL_US, FUNNEL_URL_CA } from '../../config';
import { Lead, Treatment } from '../../pages/types';
import { getCountryFlag } from '../../utils';
import { BOTTOM_TOAST } from '../../utils/toastUtils';
import { CustomerTreatments } from '../CustomerDetail/CustomerTreatments';
import { Button } from '../buttons/Button';

interface LeadDetailProps {
  lead: Lead;
  treatments?: Treatment[];
}

export const LeadDetail = ({ lead, treatments }: LeadDetailProps) => {
  const funnelUrl =
    lead.country === 'US'
      ? `${FUNNEL_URL_US}/signup/?source=continue_quiz&sessionId=${lead.id}`
      : `${FUNNEL_URL_CA}/signup/?source=continue_quiz&sessionId=${lead.id}`;

  const handleTakeQuizClick = () => {
    navigator.clipboard.writeText(funnelUrl);
    toast.success(
      'Link copied. Paste into an incognito window to continue quiz as lead.',
      BOTTOM_TOAST
    );
  };

  return (
    <div className="py-3 flex flex-col justify-center align-center gap-4">
      <div className="flex justify-between align-top">
        <h1>
          <b>Lead:</b> {`${getCountryFlag(lead.country)} ${lead.email}`}
        </h1>
        <div className="flex items-center gap-3">
          <Button label="Take Quiz as Lead" variant="primary" onClick={handleTakeQuizClick} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <AccountAndContactInfo lead={lead} />
        <CustomerTreatments treatments={treatments} isLead />
      </div>
    </div>
  );
};
